import { render, staticRenderFns } from "./CarefullyChosenDetail.vue?vue&type=template&id=03d333f4&scoped=true&"
import script from "./CarefullyChosenDetail.vue?vue&type=script&lang=js&"
export * from "./CarefullyChosenDetail.vue?vue&type=script&lang=js&"
import style0 from "./CarefullyChosenDetail.vue?vue&type=style&index=0&id=03d333f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d333f4",
  null
  
)

export default component.exports